import { render, staticRenderFns } from "./CampaignBillings.vue?vue&type=template&id=28d05c85&"
import script from "./CampaignBillings.vue?vue&type=script&lang=js&"
export * from "./CampaignBillings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports